module.exports = __webpack_public_path__ + "static/media/Card3partner.feaa2836.png";